import React from 'react';
import { NumberInput } from '../../../../../shared/components/ui/atoms';
import { defaultValues } from '../constants';
import { getErrors } from '../utils';

interface LoanBuilderInputProps {
  label: any;
  customKey: string;
  values: any;
  setValue: (key: string, value: any) => void;
  isDisabled: boolean;
  labelText: any;
  loanAmount: number;
}

export const LoanBuilderInput = ({ 
  label, 
  customKey, 
  values, 
  setValue, 
  isDisabled, 
  labelText, 
  loanAmount 
}: LoanBuilderInputProps) => {
  return (
    <NumberInput
      label={label}
      value={values[customKey]}
      setValue={(v: number) => setValue(customKey, v)}
      defaultValue={defaultValues[customKey as keyof typeof defaultValues] as number}
      error={getErrors({ label, customKey, values, labelText, loanAmount })}
      isDisabled={isDisabled}
    />
  )
}

